import addressModel from "../atoms/address.model"
import cropModel from "../atoms/crop.model"
import { string, mixed, object, number, array } from "yup"
import { ID } from "../yup.common"
export default object({
  id: ID,
  name: string().label("Plot Name"),
  codename: string().label("Plot Code"),
  area: number().label("Area"),
  company: mixed().label("Company").required("Company Is Required"),
  farmer: number().label("Plot Farmer"),
  address: addressModel,
  crops: array(cropModel).label("Plot Crops"),
  gatNumber: string()
    .required("Please enter a valid gat number")
    .label("Gat Number"),
})
